import axios from "axios";
import LocalStorageUtil from "../utils/localStorage";

const baseUrl = process.env.REACT_APP_API_URL; // Get the base URL from urlConfig

const apiClient = axios.create({
  baseURL: baseUrl, // Set the base URL
  withXSRFToken: true,
  headers: {
    "Content-Type": "application/json",
    AccountId: LocalStorageUtil.getItem("accountId"),
  },
});

apiClient.interceptors.request.use(
  (config) => {
    // Dynamically fetch the token and anti-forgery tokens from local storage

    config.headers.Authorization = `Bearer ${LocalStorageUtil.getItem("token")}`;

    config.headers["X-XSRF-TOKEN"] = LocalStorageUtil.getItem("antiforgery");

    config.headers["XSRF-Cookie-TOKEN"] =
      LocalStorageUtil.getItem("antiforgerycookie");

    config.headers["BusinessUnitId"] = LocalStorageUtil.getItem("businessUnitId");

    return config;
  },
  (error) => {    
     return Promise.reject(error instanceof Error ? error : new Error(String(error)));
  }
);

export const postCall = async (apiUrl: string, params: any, config?: any) => {
  try {
    const body = {
      paramGetUrl: apiUrl,
      paramPost: params,
    };
    const response = await apiClient.post("api/ServerPost", body);

    return response;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};
export const getAzureCall = async (apiUrl: string) => {
  try {
    const apiClientAzure = axios.create({
      baseURL: "",
      withXSRFToken: true,
      headers: {
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": `${process.env.REACT_APP_ARCHIVESEARCH_OCP_APIM_SUBSCRIPTION_KEY}`,
      },
    });
    
    const response = await apiClientAzure.get(apiUrl);

    return response;
  } catch (error) {
    console.error("Error calling Azure GET endpoint", error);
    throw error;
  }
};


export const postCallFormData = async (
  apiUrl: string,
  params: any,
  config?: any
) => {
  try {
    const apiClientFormData = axios.create({
      baseURL: baseUrl, // Set the base URL
      withXSRFToken: true,
      headers: {
        "Content-Type": "multipart/form-data",
        AccountId: LocalStorageUtil.getItem("accountId"),
        Authorization: `Bearer ${LocalStorageUtil.getItem("token")}`,
        "X-XSRF-TOKEN": LocalStorageUtil.getItem("antiforgery"),
        "XSRF-Cookie-TOKEN": LocalStorageUtil.getItem("antiforgerycookie"),
        BusinessUnitId: LocalStorageUtil.getItem("businessUnitId"),
      },
    });
    const formData = new FormData();
    formData.append("paramGetUrl", apiUrl);
    formData.append("paramPost", JSON.stringify(params));
    const response = await apiClientFormData.post("api/ServerUpload", formData);
    return response;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getCall = async (apiUrl: string, apidata: string) => {
  try {
    const url = `api/ServerGet?paramGet=${encodeURIComponent(
      apidata
    )}&paramGetURL=${encodeURIComponent(apiUrl)}`;
    const response = await apiClient.get(url);

    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const postFileDownloadCall = async (apiUrl: string, params: any) => {
  try {
    const body = {
      paramGetUrl: apiUrl,
      paramPost: params,
    };
    const response = await apiClient.post("api/ServerPost", body, {
      responseType: "arraybuffer",
    });
    return response;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};
export const postCallFormDataNote = async (  
  params: FormData,
  
) => {
  try {
    debugger;
    const apiClientFormData = axios.create({
      baseURL: baseUrl,
      withXSRFToken: true,
      headers: {
        "Content-Type": "multipart/form-data",
        AccountId: LocalStorageUtil.getItem("accountId"),
        Authorization: `Bearer ${LocalStorageUtil.getItem("token")}`,
        "X-XSRF-TOKEN": LocalStorageUtil.getItem("antiforgery"),
        "XSRF-Cookie-TOKEN": LocalStorageUtil.getItem("antiforgerycookie"),
        BusinessUnitId: LocalStorageUtil.getItem("businessUnitId"),
      },
    });
    const response = await apiClientFormData.post("api/ServerUpload", params);
    return response;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const postCallSaveUpdateDeleteExcelData = async (
  params: FormData,
) => {
  try {
    const apiClientFormData = axios.create({
      baseURL: baseUrl, // Set the base URL
      withXSRFToken: true,
      headers: {
        "Content-Type": "multipart/form-data",
        AccountId: LocalStorageUtil.getItem("accountId"),
        Authorization: `Bearer ${LocalStorageUtil.getItem("token")}`,
        "X-XSRF-TOKEN": LocalStorageUtil.getItem("antiforgery"),
        "XSRF-Cookie-TOKEN": LocalStorageUtil.getItem("antiforgerycookie"),
        BusinessUnitId: LocalStorageUtil.getItem("businessUnitId"),
      },
    });
    
    const response = await apiClientFormData.post("api/ServerUpload", params);
    return response;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};